import { associationTypes } from './types';

const { replacedBy, isChildOf } = associationTypes;

/**
 * These helper functions are for simplifying list association-based operations (maps, filters, find, etc) on an item list
 */

// Function creators for getting relevent associations
export const filterAssociationsTo = (filterAssociationType) => (item) => (item.associationsTo.filter(({ associationType: t }) => t === filterAssociationType));
export const filterAssociationsFrom = (filterAssociationType) => (item) => (item.associationsFrom.filter(({ associationType: t }) => t === filterAssociationType));

// Short-hand filter function for retrieving the children given an item
export const childAssociations = (item) => filterAssociationsFrom(isChildOf)(item);
export const parentAssociations = (item) => filterAssociationsTo(isChildOf)(item);

// Short-hand for getting behaviours of an item based on certain associations.
export const isNotChildOfAnotherItem = (item) => filterAssociationsTo(isChildOf)(item).length === 0;
export const isNotReplacedByAnotherItem = (item) => filterAssociationsTo(replacedBy)(item).length === 0;